import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm, useFieldArray } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { createDarazOrderValidationForm } from "../../utils/validationSchemas";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useEffect } from "react";
import NumberField from "../Reusable/NumberField";
import ProductTypeComboboxInput from "../Reusable/ProductTypeComboBox";
import Form from "./Form";

const CreateDarazOrder = (props: any) => {
  const { handleCreate, isLoading, defaultBranch } = props;
  const defaultBranchParseValue = JSON.parse(defaultBranch);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
    control,
    watch,
  } = useForm<any>({
    resolver: yupResolver(createDarazOrderValidationForm),
    defaultValues: {
      from_branch: defaultBranchParseValue,
    },
  });

  const isActive = true;

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Submit"}
      isLoading={isLoading}
    >
      <Form
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
        isEdit={false}
        watch={watch}
      />
    </FormLayout>
  );
};

export default CreateDarazOrder;
